module.exports = __webpack_public_path__ + "images/emoji/syringe.b183dc18cd1e1d2cf4dc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/syringe.png
// module id = Pr3W
// module chunks = 14